// Explicit choices for new purchases. Never fill a missing choice with Other:
// item classification must describe the piece the operator actually reviewed.
export const GOLD_ITEM_TYPES = Object.freeze([
  { value: 'ring', label: 'Ring' },
  { value: 'chain', label: 'Chain' },
  { value: 'bracelet', label: 'Bracelet' },
  { value: 'anklet', label: 'Anklet' },
  { value: 'necklace', label: 'Necklace' },
  { value: 'pendant', label: 'Pendant' },
  { value: 'earring', label: 'Earring' },
  { value: 'watch', label: 'Watch' },
  { value: 'coin', label: 'Coin' },
  { value: 'bar', label: 'Bar' },
  { value: 'scrap', label: 'Scrap' },
  { value: 'other', label: 'Other' },
].map(Object.freeze))

export function isGoldItemType(value) {
  return GOLD_ITEM_TYPES.some(option => option.value === value)
}

export function getGoldItemTypeErrors(items = []) {
  return items.flatMap((item, index) => Number(item.weight) > 0 && !isGoldItemType(item.itemType)
    ? [{ index, itemId: item.id ?? item.itemId, message: `Item ${index + 1}: choose an item type before starting the purchase.` }]
    : [])
}

function enteredNumber(value) {
  if (typeof value === 'number') return Number.isFinite(value) ? value : NaN
  if (typeof value !== 'string' || !/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i.test(value.trim())) return NaN
  const number = Number(value.trim())
  return Number.isFinite(number) ? number : NaN
}

// Every visible row is part of the intended purchase. An operator must complete
// it or remove it; validation never silently drops a row or supplies defaults.
export function getGoldItemErrors(items = []) {
  return items.flatMap((source, index) => {
    const item = source && typeof source === 'object' && !Array.isArray(source) ? source : {}
    const errors = []
    const add = (field, message) => errors.push({
      index, itemId: item.id ?? item.itemId, field, message: `Item ${index + 1}: ${message}`,
    })
    if (item.metal !== 'gold' && item.metal !== 'silver') add('metal', 'choose Gold or Silver.')
    if (item.metal === 'gold') {
      const whole = enteredNumber(item.karatWhole)
      const decimal = enteredNumber(item.karatDecimal)
      if (!Number.isInteger(whole) || !Number.isInteger(decimal) ||
          whole < 1 || whole > 24 || decimal < 0 || decimal > 99 || whole + decimal / 100 > 24) {
        add('purity', 'select both purity values, from 1K through 24.00K.')
      }
    }
    const weight = enteredNumber(item.weight)
    if (!(weight > 0)) add('weight', 'enter a valid weight greater than zero.')
    if (!isGoldItemType(item.itemType)) add('type', 'choose an item type.')
    return errors
  })
}
